import React from 'react';
import AppRouter from './AppRouter';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import { theme } from './styles/theme';
import { ToastContainer } from 'react-toastify';
import { Tooltip } from 'react-tooltip';


const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ToastContainer />
      <Tooltip
        id="global-tooltip"
        positionStrategy="fixed"
        style={{ zIndex: 9999 }}
      />     
      <AppRouter />
    </ThemeProvider>
  );
};

export default App;
